module.exports = __webpack_public_path__ + "img/combination_symbols@2x.53bc682.jpg";